<script>
export default {
    name: "CalculatorDataProvider",
    computed: {
        calculatorFullData() {
            return this.$store.getters.calculatorFullData;
        },
        categoryGroupedIDs() {
            const categoryIDs = [];
            this.$store.getters.calculatorFullData.forEach(calculation => {
                if(calculation.treatments && calculation.treatments.length > 0) {
                    calculation.treatments.forEach(treatment => {
                        treatment.forEach(drug=> {
                            if(drug.filters.category && drug.filters.category.length > 0) {
                                drug.filters.category.forEach( category => {
                                    categoryIDs.push(category);
                                })
                            }
                        })
                    })
                }
            });
            return _.uniq(categoryIDs);
        },
    },
    methods: {
        //getters

        getTreatmentCategoryIDs(calculationIdx, treatmentIdx) {
            let categoryIDs = []
            const calculation = this.$store.getters.calculatorFullData[calculationIdx];
            if(calculation && calculation.treatments) {
                const treatment = calculation.treatments[treatmentIdx];
                if(treatment && treatment.length > 0 ){
                    treatment.forEach(drug => {
                        if(drug.filters.category) {
                            categoryIDs = categoryIDs.concat(drug.filters.category);
                        }
                    });
                }
            }

            return categoryIDs;
        },
        getDrug(calculationIdx, treatmentIdx, drugIdx) {
            const calculation = this.$store.getters.calculatorFullData[calculationIdx];
            if (!calculation && !calculation.treatments[treatmentIdx][drugIdx]) return false
            return calculation.treatments[treatmentIdx][drugIdx];
        },

        getCultureId(idx) {
            const calculation = this.$store.getters.calculatorFullData[idx];
            if(calculation && calculation.cultureId) {
                return calculation.cultureId
            }
            return null;
        },
        getHectaresCnt(idx) {
            const calculation = this.$store.getters.calculatorFullData[idx];
            if(calculation && calculation.hectaresCnt) {
                return calculation.hectaresCnt
            }
            return null;
        },
        getTreatmentsCnt(idx) {
            const calculation = this.$store.getters.calculatorFullData[idx];
            if(calculation && calculation.treatments) {
                return calculation.treatments.length
            }
            return null;
        },

        //setters
        setDefaultItem() {
            this.$store.commit('calculatorSetDefaultItem');
        },
        setCalculatorFullData(data) {
            this.$store.commit('calculatorSetFullData', data);
        },
        setBudget(budget, calculationIdx, treatmentIdx, drugIdx) {
            this.$store.commit('calculatorSetBudget', {
                calculationIdx: calculationIdx,
                treatmentIdx: treatmentIdx,
                drugIdx: drugIdx,
                budget: budget
            })
        },
        setCultureId(cultureId, idx) {
            this.$store.commit('calculatorSetCultureId', {
                idx: idx,
                cultureId: cultureId
            })
        },
        setHectaresCnt(hectaresCnt, idx) {
            this.$store.commit('calculatorSetHectaresCnt', {
                idx: idx,
                hectaresCnt: hectaresCnt
            })
        },
        setSelectedCategories(calculationIdx, treatmentIdx, categoryIDs) {
            this.$store.commit('calculatorSetCategoryIDs', {
                calculationIdx: calculationIdx,
                treatmentIdx: treatmentIdx,
                categoryIDs: categoryIDs
            })
        },
        setTreatmentsCnt(treatmentsCnt, idx) {
            const treatments = [];
            for (let i = 0; i < treatmentsCnt; i++) {
                treatments.push([]);
            }
            this.$store.commit('calculatorSetTreatments', {
                idx: idx,
                treatments: treatments
            })
        },
        setDrugFilter(filter, calculationIdx, treatmentIdx, drugIdx) {
            this.$store.commit('calculatorSetFilter', {
                calculationIdx: calculationIdx,
                treatmentIdx: treatmentIdx,
                drugIdx: drugIdx,
                filter: filter
            })
        },
        deleteCategory(calculationIdx, treatmentIdx, categoryId) {
            this.$store.commit('calculatorDeleteCategoryId', {
                calculationIdx: calculationIdx,
                treatmentIdx: treatmentIdx,
                categoryId: categoryId
            })

        },
        deleteFilterValue(calculationIdx, treatmentIdx, drugIdx, filterName, filterValueId) {
            this.$store.commit('calculatorDeleteFilter', {
                calculationIdx: calculationIdx,
                treatmentIdx: treatmentIdx,
                drugIdx: drugIdx,
                filterName: filterName,
                filterValueId: filterValueId
            })
        },
        deleteCalculation(idx) {
            this.$store.commit('calculatorDeleteCalculation', idx)
        },
        resetCalculator() {
            this.$store.commit('calculatorResetAllData');
        }
    }
}
</script>
